export default __webpack_public_path__ + "static/media/succsess_green.93ebe419.svg";